import { useEffect } from 'react';
import { IDBScanParameters } from './db-scan-interfaces';
import { useDBScanStore } from './dal/db-scan-store';
import DBScanParameters from './ui/parameters';
import Table from './ui/table';

/*
{
    "epsilon":2.1,
    "minPoints":4,
    "points":[
        ["A",1,4],["B",2,2],["C",2,4],["D",2,9],["E",3,4],["F",3,5],["G",3,7],["H",4,4],["I",4,5],["J",6,1],["K",7,2],["L",7,3],["M",7,5],["N",7,6],["O",9,3]
    ]
}
 */

const initialParameters: IDBScanParameters = {
    "epsilon": 2.1,
    "minPoints": 4,
    "points": [
        [
            "A",
            1,
            4
        ],
        [
            "B",
            2,
            2
        ],
        [
            "C",
            2,
            4
        ],
        [
            "D",
            2,
            9
        ],
        [
            "E",
            3,
            4
        ],
        [
            "F",
            3,
            5
        ],
        [
            "G",
            3,
            7
        ],
        [
            "H",
            4,
            4
        ],
        [
            "I",
            4,
            5
        ],
        [
            "J",
            6,
            1
        ],
        [
            "K",
            7,
            2
        ],
        [
            "L",
            7,
            3
        ],
        [
            "M",
            7,
            5
        ],
        [
            "N",
            7,
            6
        ],
        [
            "O",
            9,
            3
        ],
        [
            "P",
            5,
            3
        ]
    ]
};

const DbScanHome = () => {

    const params = useDBScanStore(store => store.params);
    const setParams = useDBScanStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">DBScan (ניתוח אשכולות)</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <DBScanParameters />
                        <Table />
                    </div>
                }
            </div>

        </div>
    )
};

export default DbScanHome;
